import Swiper from 'swiper/bundle'

// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// init Swiper:
const swiper = new Swiper('.swiper-imgs', {
	autoplay: {
		delay: 5000
	},
	loop: true,
	slidesPerView: 2,
	spaceBetween: 5,
	breakpoints: {
		640: {
			slidesPerView: 3,
			spaceBetween: 20
		},
		768: {
			slidesPerView: 4,
			spaceBetween: 20
		},
		1024: {
			slidesPerView: 6,
			spaceBetween: 20
		}
	}
})

const openModal = src => {
	const modal = document.createElement('div')
	modal.className = 'modal fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50 overflow-y-scroll'

	const modalContent = document.createElement('div')
	modalContent.className =
		'modal-content w-[90%] max-w-[600px] h-auto relative top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 overflow-hidden  max-h-[90vh]'

	const img = document.createElement('img')
	img.src = src
	img.alt = 'Modal'
	img.className = 'w-full h-auto object-contain'
	const closeModalButton = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
	closeModalButton.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
	closeModalButton.setAttribute('width', '16')
	closeModalButton.setAttribute('height', '16')
	closeModalButton.setAttribute('fill', '#fff')
	closeModalButton.setAttribute('class', 'bi bi-x-lg absolute top-2 right-2 w-6 h-6 cursor-pointer z-50')
	closeModalButton.setAttribute('viewBox', '0 0 16 16')
	closeModalButton.innerHTML =
		'<path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>'
	closeModalButton.onclick = () => document.body.removeChild(modal)

	modal.onclick = event => {
		if (event.target === modal) {
			document.body.removeChild(modal)
		}
	}

	modal.appendChild(modalContent)
	modalContent.appendChild(closeModalButton)
	modalContent.appendChild(img)
	document.body.appendChild(modal)
}

document.querySelectorAll('.swiper-imgs img').forEach(img => {
	img.onclick = () => {
		openModal(img.src)
	}
})
